/** Resolve stored upload paths (e.g. /uploads/...) for use in img src */
export function uploadUrl(path) {
  if (!path) return null;
  if (path.startsWith('blob:') || path.startsWith('http')) return path;
  return path.startsWith('/') ? path : `/${path}`;
}
